function scrollToHashWithTimeout(hash: string, timeout = 500): void {
    const element: HTMLElement = document.querySelector(hash);

    if (element instanceof HTMLElement) {
        const startTime = performance.now();
        const waitAndScroll = (timestamp: number) => {
            if (timestamp - startTime >= timeout) {
                element.scrollIntoView({ behavior: 'smooth' });
            } else {
                requestAnimationFrame(waitAndScroll);
            }
        };

        requestAnimationFrame(waitAndScroll);
    }
}

window.addEventListener('load', () => {
    const hash = window.location.hash;

    if (hash) {
        scrollToHashWithTimeout(hash);
    }
});
